import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_AdmissionCriteria = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_AdmissionCriteria' className='file-pdf-document'>
            <div className='file-template'>



                <p className='w-750'><h3>Adult 65D-30 Outpatient ASAM Level I</h3></p>
                <p className='w-750'><b>Circle all items in each dimension that apply to the client. Place a check in the 'yes' or 'no' box that indicates validation or lack of validation for placement into this level of care.</b></p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>DIMENSIONS</span>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'>ADMISSION CRITERIA</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>ASAM Requirements</b>
                        </td>
                        <td className='w-450'>
                            <b>Meets criteria in all six dimensions</b>
                        </td>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-50'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 1:</b> Acute Intoxication and/or Withdrawal Potential
                        </td>
                        <td className='w-450'>The client's status in this dimension is characterized by one the following:<br />
                            a. Client is free intoxication or withdrawal symptoms/risks; or
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish_Yes' name='rbEnglish' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish_No' name='rbEnglish' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. The client's intoxication or withdrawal symptoms/risks can be managed at this level of care.
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish1_Yes' name='rbEnglish1' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish1_No' name='rbEnglish1' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td  className='w-750'>
                            <hr />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 2:</b> Biomedical Conditions and Complications
                        </td>
                        <td className='w-450'>None or very stable - The client's biomedical conditions, if any, are stable enough to participate in outpatient treatment.
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish2_Yes' name='rbEnglish2' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish2_No' name='rbEnglish2' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td  className='w-750'>
                            <hr />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 3:</b> Emotional, Behavioral or Cognitive Conditions and Complications
                        </td>
                        <td className='w-450'>None or very stable - The situation is characterized by all of the following:
                            <br />
                            a. The client's anxiety, guilt and/or depression, if present, appear to be related to substance-related problems rather than to a coexisting psychiatric/emotional/behavioral or cognitive condition. If they are related to such a condition, appropriate care is being concurrent with ASAM Level I; and
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish3_Yes' name='rbEnglish3' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish3_No' name='rbEnglish3' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. The client's mental status does not preclude his/her ability to understand the materials presented or to participate in the treatment process; and
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish4_Yes' name='rbEnglish4' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish4_No' name='rbEnglish4' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>c. The client is assessed as not posting a risk of harm to self or others.
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish5_Yes' name='rbEnglish5' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish5_No' name='rbEnglish5' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>
                            <b>Dual Diagnosed Enhanced Programs</b> In addition to be foregoing criteria, either (a) or (b) and (d) characterize the client's status in Dimension 3.
                            <br />
                            (a) The client has a severe and persistent mental illness that impairs his or her ability to follow through consistently with mental health appointments and psychotropic medication. The client maintains the ability to access service such as assertive community treatment and intensive case management or supportive living designed to help the client remain engaged in treatment; or
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish6_Yes' name='rbEnglish6' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish6_No' name='rbEnglish6' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>(b) The client has severe and persistent mental disorder or other emotional, behavioral or cognitive problems, or substance-induced disorder; and
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish7_Yes' name='rbEnglish7' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish7_No' name='rbEnglish7' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>(c) The client's mental health functioning is such that he or she has impaired ability to: [1] understand the information presented, and [2] participate in treatment planning and the treatment process. Mental health management is required to stabilize mood, cognition and behavior; and
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish8_Yes' name='rbEnglish8' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish8_No' name='rbEnglish8' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>(d) The client is assessed as not posing a risk of harm to self or others and is not vulnerable to victimization by another.
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish9_Yes' name='rbEnglish9' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish9_No' name='rbEnglish9' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td  className='w-750'>
                            <hr />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 4:</b> Readiness to Change
                        </td>
                        <td className='w-450'>The situation is characterized by (a) and (b) or (c) or (d):<br />
                            a. The client wants to adhere to the treatment plan and attend all scheduled activities; and
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish10_Yes' name='rbEnglish10' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish10_No' name='rbEnglish10' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. The client admists to a substance abuse and/or a mental health problem but requires monitoring and motivating strategies. A structured residential program is not required; or
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish11_Yes' name='rbEnglish11' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish11_No' name='rbEnglish11' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>c. The client is ambivalent about or does not recognize that he or she has a substance related and/or mental health problem; or
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish12_Yes' name='rbEnglish12' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish12_No' name='rbEnglish12' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>d. The client may not recognize that they have a substance-related and/or mental health problem. They may require monitoring and motivating strategies to engage in treatment and to progress through the stages of change.
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish13_Yes' name='rbEnglish13' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish13_No' name='rbEnglish13' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td  className='w-750'>
                            <hr />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 5:</b> Relapse/Continued Use Potential
                        </td>
                        <td className='w-450'>Able to maintain abstinence and pursue recovery goals with minimal support - The client is assessed as being able to achieve or maintain abstinence and recovery goals only with support and scheduled counseling to assist in dealing with issues that include mental preoccupation with alcohol or other drugs, craving, peer pressure, lifestyle, attitude changes and other treatment plans issues. <b>Dual Diagnosed Enhanced Programs</b> In addition to the criteria listed above, the client is assessed as able to achieve or maintain mental health functioning and related goals only with support and scheduled therapeutic contact to assist him or her in dealing with issues that include (but are not limited to) impulses to harm self or others and difficulty in coping with his or her affects, impulses or cognition.
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish14_Yes' name='rbEnglish14' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish14_No' name='rbEnglish14' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td  className='w-750'>
                            <hr />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 6:</b> Recovery Environment
                        </td>
                        <td className='w-450'>The situation is characterized by one of the following:<br />
                            a. A sufficiently supportive psychosocial environment makes outpatient treatment feasible; or
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish15_Yes' name='rbEnglish15' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish15_No' name='rbEnglish15' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td  className='w-750'>
                            <hr />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 6:</b> Recovery Environment
                        </td>
                        <td className='w-450'>The client's status in this dimension is characterized by one of the following:
                            <br />
                            a. The client has resolved problems in his/her living environment or demonstrates the needed coping skills necessary to achieve personal goals and does not meet any other crietria indicating a need for continued service at this level of care; or
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish16_Yes' name='rbEnglish16' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish16_No' name='rbEnglish16' className='add-only' value='2' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. The client is no longer willing to examine problems in his/her living environment, despite program efforts. Since these problems persist, a recommendation is being made for appropriate living and support services.
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish17_Yes' name='rbEnglish17' className='add-only' value='1' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEnglish17_No' name='rbEnglish17' className='add-only' value='2' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Recommendations/Notes:</span>
                    <textarea id='txtRecommendations' name='txtRecommendations' className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}

